<template>
  <div class="dashboard">
    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-primary mb-10" @click="refreshPageData()">
          <i class="fa fa-refresh" aria-hidden="true"></i> Clear cache and
          refresh page data
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <fabric-statistics
          @changed="serverParamsChanged"
          :pageData="pageData"
          :serverParams="serverParams"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <fabric-ordering :pageData="pageData" />
      </div>
    </div>
    <div class="loading" v-if="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
import FabricStatistics from "./dashboardComponents/FabricStatistics";
import FabricOrdering from "./dashboardComponents/FabricOrdering";
export default {
  components: {
    FabricStatistics,
    FabricOrdering,
  },

  data() {
    return {
      loading: true,
      pageData: {},
      serverParams: {
        inventory: {
          fabricId: null,
          lastXMonths: 1,
        },
        tableGraph: {
          salePeriod: "1y",
          salePeriodStart: null,
          salePeriodEnd: null,
        },
        refreshData: 0,
      },
      allFabrics: [],
    };
  },

  mounted() {
    this.getFabrics();
  },

  methods: {
    serverParamsChanged() {
      this.getPageData();
    },

    refreshPageData() {
      this.serverParams.refreshData = 1;
      this.getPageData();
    },

    async getFabrics() {
      let response = await axios.get("/v2/fabrics?as_dropdown=1");
      this.allFabrics = response.data.data.collection;
      this.serverParams.inventory.fabricId = this.allFabrics[0].id;
      if (response) {
        this.getPageData();
      }
    },

    async getPageData() {
      this.loading = true;

      // Format date ranges to YYYY-MM-DD format
      if (
        this.serverParams.tableGraph.salePeriodStart !== null &&
        this.serverParams.tableGraph.salePeriodEnd !== null
      ) {
        this.serverParams.tableGraph.salePeriodStart = this.convertDateToString(
          this.serverParams.tableGraph.salePeriodStart
        );
        this.serverParams.tableGraph.salePeriodEnd = this.convertDateToString(
          this.serverParams.tableGraph.salePeriodEnd
        );
      }

      try {
        let res = await axios.post("/v2/fabrics/dashboard", this.serverParams);
        this.pageData = res.data;
        this.loading = false;
        this.serverParams.refreshData = 0;
      } catch (error) {
        this.loading = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
    convertDateToString(date) {
      if (typeof date !== "string") {
        const offset = date.getTimezoneOffset();
        date = new Date(date.getTime() - offset * 60 * 1000);
        return date.toISOString().split("T")[0];
      }
      return date;
    },
  },
};
</script>

<style lang="scss">
.dashboard {
  .scroll-div {
    .grid-body {
      height: 600px;
      width: 100%;
      overflow: scroll;
    }
    .table th {
      position: sticky;
      top: -1px;
    }
  }
  .flex {
    display: flex;
    width: 100%;
    .grid {
      width: 100%;
      height: 100%;
    }
  }
  .loading {
    bottom: 0px;
    font-size: 150px;
    position: fixed;
    padding-top: 20%;
    top: 0px;
    text-align: center;
    width: 100%;
    left: 0px;
    right: 0px;
    background: #ffffffa8;
    color: #202529a3;
  }
}
</style>
